<template>
  <div class="container px-5 space-y-10 lg:space-y-16 my-12 lg:mt-36">
    <div class="grid gap-8">
      <div class="w-full rounded-lg flex flex-col sm:flex-row text-white">
        <div class="relative w-full overflow-hidden sm:rounded-l-md">
          <nuxt-img
            format="webp"
            src="images/lista-nascita-banner.jpg"
            class="w-full h-full object-cover rounded-t-lg sm:rounded-tr-none sm:rounded-l-md"
          />
          <div
            class="absolute bg-cerise-red-600 flex justify-end p-6 items-start size-28 -bottom-10 -left-8 rounded-full z-10"
          >
            <nuxt-img src="images/services/lista-nascita.svg" class="w-3/4" />
          </div>
        </div>
        <div
          class="bg-cerise-red-600 rounded-b-lg sm:rounded-bl-none sm:rounded-r-lg w-full py-9 pl-5 pr-5 flex flex-col justify-center md:gap-10 xl:gap-0 xl:justify-between text-center sm:text-start"
        >
          <h1 class="text-lg lg:text-3xl font-extrabold mb-4">
            LISTA NASCITA
          </h1>
          <p class="mb-5">
            Se apri una lista nascita con noi ricevi un buono sconto del 20% spendibile
            sull'abbigliamento Prénatal ogni 200 punti accumulati con prodotti della lista nascita e, solo fino al 7/12, due buoni sconto 10€ su
            30€ di spesa minima sulla prima infanzia.<br /><br />
            A chiusura lista, se l'importo è uguale o superiore ai 1000€ e inferiore ai 1500€ ricevi <strong>2 buoni sconto da 50€</strong>.<br />
            Se l'importo è uguale o superiore ai 1500€ e inferiore a 2000€ ricevi <strong>3 buoni sconto da 50€</strong>.<br />
            Se l'importo è uguale o superiore ai 1500€ e inferiore a 2000€ ricevi <strong>4 buoni sconto da 50€</strong>.<br />
          </p>
          <nuxt-link
            target="_blank"
            to="https://www.prenatal.com/regolamento-lista-nascita/"
            class="w-fit"
          >
            <CorePrimaryButton class="mt-4 !border-white">
              SCOPRI DI PIÙ
            </CorePrimaryButton>
          </nuxt-link>
        </div>
      </div>
    </div>
    <HomepageExclusieBenefitsSeciton />
    <HomepageFaq />
  </div>
</template>

<script setup>
import { CoreOutlineButton } from "#components";

const config = useRuntimeConfig().public;
</script>
